import { useEffect, useState } from 'react';
import { SITE_ANNOUNCEMENT_LIST_PATH, SiteAnnouncement, SiteAnnouncementType } from 'core/siteAnnouncement/SiteAnnouncement';
import { Redirect } from 'react-router-dom';
import { useCoreContext } from 'contexts/coreContext';
import { DefaultSiteAnnouncementManager } from 'core/siteAnnouncement/SiteAnnouncementManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { compact } from 'lodash';

const siteAnnouncementManager = new DefaultSiteAnnouncementManager();

export const RedirectAnnouncement: React.FC = () => {

  const [announcement, setAnnouncement] = useState<SiteAnnouncement>();

  const core = useCoreContext();
  const { callAPIs } = useCallAPI();

  const authenticationManager = core?.authenticationManager;
  const vendorNumber = core?.accountManager.localeMeta?.vendorNumber;

  useEffect(() => {
    if (!authenticationManager || !vendorNumber) {
      setAnnouncement(undefined);
      return;
    }

    callAPIs(
      [() => siteAnnouncementManager.getTopAnnouncement(vendorNumber)],
      (response: SiteAnnouncement[] | SiteAnnouncement | undefined) => {
        // 型別容忍：BE 若被 rollback 成舊版會回單一物件（或空 body），此時退化成「只看最新那一則」
        const topAnnouncements = Array.isArray(response) ? response : compact([response]);
        // BE 已依 publishTime DESC 排序，直接取第一則未讀的
        const firstUnread = topAnnouncements.find(
          (topAnnouncement: SiteAnnouncement) => !authenticationManager.hasReadAnnouncement(topAnnouncement)
        );
        setAnnouncement(firstUnread);
      }
    );
  }, [authenticationManager, vendorNumber, callAPIs]);

  if (!announcement) {
    return null;
  }

  return (
    <Redirect
      to={{
        // type 在相容期可能缺席（BE @JsonInclude(NON_NULL) 下是 undefined 而不是 null），不 fallback 會導到 /undefined
        pathname: SITE_ANNOUNCEMENT_LIST_PATH[announcement.type ?? SiteAnnouncementType.SYSTEM],
        state: { autoOpenAnnouncementId: announcement.id }
      }}
    />
  );
};
